<template>
    <svg id="a" width="48" height="48" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 355.39 306.5">
        <defs>
            <linearGradient id="b" x1="0" y1="98.63" x2="184.54" y2="98.63" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#fab641"/>
                <stop offset=".51" stop-color="#f6a53c"/>
                <stop offset="1" stop-color="#f39236"/>
            </linearGradient>
        </defs>
        <path d="m341.81,46.81c-9.06-14.48-21.25-25.91-36.57-34.27-15.33-8.36-32.6-12.54-51.83-12.54h-36.38l-9.76,42.89h38.17c7.99,0,15.62,1.23,22.88,3.68,7.27,2.45,13.85,6.09,19.75,10.9,5.9,4.81,10.58,10.72,14.03,17.71,3.45,6.99,5.17,14.94,5.17,23.83s-1.81,16.85-5.45,23.83c-3.63,6.99-8.53,12.9-14.71,17.7-6.17,4.81-13.3,8.44-21.38,10.9-8.08,2.45-16.66,3.68-25.74,3.68h-58.26l-34.59,151.39,55.99-39.32,16.1-69.92h28.74c20.34,0,38.52-4.38,54.54-13.17,16.02-8.78,28.84-20.83,38.45-36.15,9.61-15.32,14.42-32.74,14.42-52.24,0-18.11-4.53-34.41-13.58-48.9Z" :fill="fill" />
        <path d="m115.29,155.12c-9.08,0-17.66-1.23-25.74-3.68-8.08-2.45-15.21-6.08-21.38-10.9-6.18-4.81-11.08-10.71-14.71-17.7-3.64-6.99-5.45-14.94-5.45-23.83s1.72-16.84,5.17-23.83c3.45-6.99,8.13-12.89,14.03-17.71,5.9-4.81,12.48-8.44,19.75-10.9,7.26-2.45,14.89-3.68,22.88-3.68h64.94L184.54,0h-73.13c-15.62,0-30.19,2.37-43.72,7.08-13.53,4.72-25.29,11.53-35.28,20.43-9.99,8.9-17.89,19.34-23.7,31.33C2.9,70.83,0,83.99,0,98.34s2.81,28.1,8.44,40.18c5.63,12.08,13.48,22.52,23.56,31.33,10.08,8.81,21.83,15.57,35.28,20.29,13.44,4.72,28.05,7.08,43.86,7.08l17.82.05h10.7l9.59-42.15h-33.96Z" style="fill:url(#b);"/>
    </svg>
</template>

<script>
export default {
    name: "InitialsCarprof",
    props: {
        fill: {
          type: String,
          required: false,
          default: "#37444c"
        }
    }
}
</script>
